export const ActivityTypes = {
  ACTIVE_USER: 'active_user',
  PAGE_VIEW: 'page_view',
  SCROLL_TO_BOTTOM: 'scroll_to_bottom'
};
